export enum LoadAllocationLabels {
  toastMessageFileCreatedError = 'No se pudo generar el archivo en el FTP',
  toastMessageFileCreatedSuccess = 'Archivo(s) guardado(s) correctamente'
}
